module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-tested-solutions.de@2x-ef20360f6b37aa3764a404e2239bbf8e.png";